import { BUS } from "../constants/data";

export const realTimeService = {
  isSuccessRequest: (code) => code === 0,

  // 실시간 설악 버스 리스트
  getListOf설악: (busList) => {
    if (!Array.isArray(busList)) {
      busList = [busList];
    }

    let realTimeBusList = [];

    busList.forEach((busInfo) => {
      if (!busInfo.predictTime1 && busInfo.predictTime1 !== 0) return;

      const remainSeat = busInfo.remainSeatCnt1 !== "" ? busInfo.remainSeatCnt1 : null;

      // 7000번이면
      if (busInfo.routeId === BUS[7000].id) {
        if (busInfo.staOrder === BUS[7000].staOrderOfSeorak) {
          realTimeBusList.push({ routeName: 7000, time: busInfo.predictTime1, remainSeat });
        }
      }
      // 7001번이면
      else if (busInfo.routeId === BUS[7001].id) {
        if (busInfo.staOrder === BUS[7001].staOrderOfSeorak) {
          realTimeBusList.push({ routeName: 7001, time: busInfo.predictTime1, remainSeat });
        }
      }
      // 7002번이면
      else if (busInfo.routeId === BUS[7002].id) {
        if (busInfo.staOrder === BUS[7002].staOrderOfSeorak) {
          realTimeBusList.push({ routeName: 7002, time: busInfo.predictTime1, remainSeat });
        }
      }
    });

    return realTimeBusList;
  },

  // 실시간 잠실 버스 리스트
  getListOf잠실: (busList) => {
    if (!Array.isArray(busList)) {
      busList = [busList];
    }

    let realTimeBusList = [];

    busList.forEach((busInfo) => {
      if (!busInfo.predictTime1 && busInfo.predictTime1 !== 0) return;

      const remainSeat = busInfo.remainSeatCnt1 !== "" ? busInfo.remainSeatCnt1 : null;

      if (busInfo.routeId === BUS[7000].id) {
        realTimeBusList.push({ routeName: 7000, time: busInfo.predictTime1, remainSeat });
      }
      else if (busInfo.routeId === BUS[7001].id) {
        realTimeBusList.push({ routeName: 7001, time: busInfo.predictTime1, remainSeat });
      }
      else if (busInfo.routeId === BUS[7002].id) {
        realTimeBusList.push({ routeName: 7002, time: busInfo.predictTime1, remainSeat });
      }
    });

    return realTimeBusList;
  }
}
